import { Flex } from 'components';
import { H2, P } from 'components/Typography/Typography';
import { useAssessmentContext } from 'contexts/AssessmentContext';
import { Cell, ValueBar } from './AssessmentThemes.styled';
import { typeColorsDict } from 'styles/theme';

export const AssessmentThemes = () => {
  const { selectedAssessments } = useAssessmentContext();

  return selectedAssessments.length ? (
    <Flex overflow="auto">
      <Flex flexDirection="column" mt={5} pb={2}>
        {selectedAssessments[0].practice?.themes.map((theme, i) => (
          <Flex key={theme.id}>
            <Flex width="200px" height="40px" alignItems="center">
              <P variant="h4">{theme.name}</P>
            </Flex>
            {selectedAssessments[0].practice?.stages.map((stage, j) => {
              return (
                <Cell
                  key={stage.id}
                  isBorderBottom={
                    i === selectedAssessments[0].practice?.themes.length - 1
                  }
                  isBorderRight={
                    j === selectedAssessments[0].practice?.stages.length - 1
                  }
                >
                  {selectedAssessments.map((assessment, k) => (
                    <ValueBar
                      key={k + theme.id}
                      value={
                        selectedAssessments[k].practice?.stages[j]?.themes[
                          theme.id - 1
                        ]?.score * 100 ?? 0
                      }
                      bgColor={
                        typeColorsDict[selectedAssessments[k].assessment_type]
                      }
                    />
                  ))}
                </Cell>
              );
            })}
          </Flex>
        ))}

        <Flex gap="10px">
          <Flex
            alignItems="center"
            justifyContent="center"
            width="200px"
          ></Flex>
          {selectedAssessments[0].practice?.stages
            ?.sort((a, b) => a.number - b.number)
            .map((stage) => (
              <Flex key={stage.id} gap="6px">
                <Flex width="150px" alignItems="center" justifyContent="end">
                  <Flex flexDirection="column" alignItems="center">
                    <H2 variant="h2">{stage.number}</H2>
                  </Flex>
                </Flex>
              </Flex>
            ))}
        </Flex>
      </Flex>
    </Flex>
  ) : (
    <></>
  );
};
